import script from "./ActionMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionMenu.vue?vue&type=script&setup=true&lang=js"

import "./ActionMenu.vue?vue&type=style&index=0&id=04177dc4&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04177dc4"]])

export default __exports__